var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-noti"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.msg)}}),(_vm.body)?_c('div',{staticClass:"body"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.body)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }